/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { loading } from './loading';
import { widgetReducer } from './reducers/widget.reducer';
import { unreadCountReducer } from './reducers/unreadCount.reducer';
import { rootSaga } from './sagas';
import { configureStore, combineReducers } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import { persistReducer, persistStore } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { errors } from './errors';
import { alertReducer } from './reducers/alert.reducer';
import { accountReducer } from './reducers/account.reducer';
import { statementReducer as statement } from './reducers/statement.reducer';
import { cmsContentReducer as cmsContent } from './reducers/cmsContent.reducer';
import { paperlessReducer as paperless } from './reducers/paperless.reducer';
import { payHistoryReducer as payHistory } from './reducers/payHistory.reducer';
import { autoPayStatusReducer as autoPay } from './reducers/autoPayStatus.reducer';
import { config } from './reducers/config.reducer';
import { fullAppReducer as fullApp } from './reducers/fullApp.reducer';
import { lipReducer as lip } from './reducers/lip.reducer';
import { lipTileReducer as lipTile } from './reducers/lipTile.reducer';
import { docReducer as doc } from './reducers/document.reducer';
const sagaMiddleware = createSagaMiddleware();

const persistConfig = {
    key: 'root',
    storage,
    whitelist: ['notification', 'doc', 'widgets']
};

const appReducers = combineReducers({
    loading: loading,
    widgets: widgetReducer,
    unreadCount: unreadCountReducer,
    account: accountReducer,
    notification: alertReducer,
    errors: errors,
    statement,
    cmsContent,
    paperless,
    payHistory,
    autoPay,
    config,
    fullApp,
    lip,
    lipTile,
    doc
});

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const rootReducer = (state: any, action: any) => {
    if (action?.type === 'logout/LOGOUT_REQUEST') {
        state = undefined;
    }
    return appReducers(state, action);
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

const store = configureStore({
    reducer: persistedReducer,
    middleware: getDefaultMiddleware => getDefaultMiddleware({ thunk: false, serializableCheck: false }).concat(sagaMiddleware)
});

const persistor = persistStore(store);
export { persistor, store };

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types,@typescript-eslint/explicit-function-return-type
export const dispatch = (action: any) => {
    store.dispatch(action);
};

sagaMiddleware.run(rootSaga);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
